import { Reducer } from "redux";
import { OrganizationUISettings } from "../../model/OrganizationUISettings";
import { AdminErrorListResponseData } from "../../service/api-response/AdminFormErrorResponse";
import * as organizationActions from "./organizationActions";

export interface OrganizationState {
  settings: {
    [organizationKeyName: string]: OrganizationUISettings;
  };
  isLoadingSettings: {
    [organizationKeyName: string]: boolean;
  };
  isUpsertingSettings: {
    [organizationKeyName: string]: boolean;
  };
  upsertErrors: {
    [organizationKeyName: string]: AdminErrorListResponseData | undefined;
  };
}

const initialState: OrganizationState = {
  settings: {},
  isLoadingSettings: {},
  isUpsertingSettings: {},
  upsertErrors: {},
};

type SupportedActions =
  | organizationActions.GetUISettingsAction
  | organizationActions.GetUISettingsSuccessAction
  | organizationActions.GetUISettingsFailAction
  | organizationActions.UpsertUISettingsAction
  | organizationActions.UpsertUISettingsSuccessAction
  | organizationActions.UpsertUISettingsFailAction;

export const organizationReducer: Reducer<
  OrganizationState,
  SupportedActions
> = (state = initialState, action): OrganizationState => {
  switch (action.type) {
    case organizationActions.GET_UI_SETTINGS: {
      return {
        ...state,
        isLoadingSettings: {
          ...state.isLoadingSettings,
          [action.organization]: true,
        },
      };
    }
    case organizationActions.GET_UI_SETTINGS_SUCCESS: {
      return {
        ...state,
        settings: {
          [action.organization]: action.data,
        },
        isLoadingSettings: {
          ...state.isLoadingSettings,
          [action.organization]: false,
        },
      };
    }
    case organizationActions.GET_UI_SETTINGS_FAIL: {
      return {
        ...state,
        isLoadingSettings: {
          ...state.isLoadingSettings,
          [action.organization]: false,
        },
      };
    }
    case organizationActions.UPSERT_UI_SETTINGS: {
      return {
        ...state,
        isUpsertingSettings: {
          ...state.isUpsertingSettings,
          [action.organization]: true,
        },
        upsertErrors: {
          [action.organization]: undefined,
        },
      };
    }
    case organizationActions.UPSERT_UI_SETTINGS_FAIL: {
      let newState = {
        ...state,
        isUpsertingSettings: {
          ...state.isUpsertingSettings,
          [action.organization]: false,
        },
      };

      if (action.errors && action.errors.length) {
        newState.upsertErrors[action.organization] = action.errors;
      }

      return newState;
    }
    case organizationActions.UPSERT_UI_SETTINGS_SUCCESS: {
      return {
        ...state,
        isUpsertingSettings: {
          ...state.isUpsertingSettings,
          [action.organization]: false,
        },
      };
    }

    default: {
      return state;
    }
  }
};
